export type DataByDate = {
  date: string;
  story_title: string;
  story_id: string;
  data: number;
};

export type DataByLocation = {
  data: number;
  country: string;
  city: string;
  value: [number, number];
};

export type VersionType = {
  visitors: number;
  session_avg_time: string;
  version_title: string;
  page_title: string;
  creator_id: string;
  version_id: string;
  story_id: string;
  created_at: string | null;
  avg_completion_level: number;
  event_url: string;
  clicked_cta_percentage: number;
  last_event_timestamp: string;
};

export type ReaderCustomField = {
  label: string;
  value: string;
};

export type ReaderType = {
  session_id: string;
  visitor_id: string;
  session_index: number;
  visitor_index: number;
  timestamp: string;
  last_event_timestamp: string;
  duration: string;
  city: string;
  country: string;
  device: string;
  /** Human / AI / Other bots - the same buckets the Traffic type chart draws. */
  traffic_type: string | null;
  /** The specific signature behind the bucket, e.g. "email-security-scanner".
   *  null means no automation signal in the user-agent, NOT a confirmed human. */
  bot_signature: string | null;
  reader_name: string | null;
  reader_email: string | null;
  reader_position: string | null;
  reader_custom_fields?: ReaderCustomField[] | null;
  click_cta: boolean;
  started_reading: boolean;
  finished_reading: boolean;
  slides_count: number;
  last_slide: number;
  single_session_visitor: boolean;
  latitude: number;
  longitude: number;
};

export type CsvType = ReaderType & {
  story_id: string;
  version_id: string;
  story_title: string;
  version_title: string;
};

export type SessionReadingDepthData = {
  event: string;
  duration: number;
  displayedTime: string;
  slide_index: number | null;
  slides_count: number | null;
};

export enum ANALYTICS_QUERY {
  STATS = "STATS",
  READERS_BY_LOCATION = "READERS_BY_LOCATION",
  SESSIONS_BY_LOCATION = "SESSIONS_BY_LOCATION",
  READERS_BY_DATE = "READERS_BY_DATE",
  SESSIONS_BY_DATE = "SESSIONS_BY_DATE",
  VERSIONS = "VERSIONS",
  READING_DEPTH = "READING_DEPTH",
  TOP_ACTIONS = "TOP_ACTIONS",
  DEVICES = "DEVICES",
  TRAFFIC_TYPE = "TRAFFIC_TYPE",
  READERS = "READERS",
  VERSION_READING_DEPTH = "VERSION_READING_DEPTH",
  SESSION_READING_DEPTH = "SESSION_READING_DEPTH",
  CSV = "CSV",
}

export type TReadersByLocation = {
  city: string | null;
  country: string;
  data: number;
  name: string;
  value: [number, number];
};

export type TReadingDepthItem = {
  number: number;
  slide: string;
  time: string;
  isViewed: boolean;
  slide_index?: number | null;
  slides_count?: number | null;
};

export type TActionItem = {
  slide_index: number;
  actions: number;
  event: string;
};

export type TPerformanceFunnelOverviewItem = {
  event: string;
  timestamp: string;
  session_id: string;
  visitor_id: string;
  total_visitors: number;
  slide_index: number | null;
};
